module.exports = __webpack_public_path__ + "img/engagement@2x.ccb0d5e.webp";